import React from 'react'
import MyTableNotFound from '../../UI/table/MyTableNotFound'
import MyTable from '../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import SupplierItem from './SupplierItem'

const SupplierTable = ({ suppliers, count, offset, setOffset, limit, setLimit, loading }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">ЄДРПОУ</TableCell>
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">Дії</TableCell>
            </>
        }
        body={
            suppliers && suppliers.length > 0 ?
                suppliers.map(supplier => 
                    <SupplierItem
                        key={supplier.id}
                        supplier={supplier} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Постачальників не знайдено' 
                    // columns={6}
                />
        }
        name='постачальників'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
        loading={loading}
    />
  )
}

export default SupplierTable